var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { emitter } from '@mantou/gem/lib/decorators';
import { GemElement } from '@mantou/gem/lib/element';
import { throttle } from '../../lib/utils';
export class DuoyunResizeBaseElement extends GemElement {
    constructor(options = {}) {
        super(options);
        this.borderBoxSize = {
            blockSize: 0,
            inlineSize: 0,
        };
        this.contentRect = {
            height: 0,
            width: 0,
        };
        const { throttle: needThrottle = true } = options;
        const callback = ([entry]) => {
            var _a;
            this.contentRect = entry.contentRect;
            this.borderBoxSize = ((_a = entry.borderBoxSize) === null || _a === void 0 ? void 0 : _a[0])
                ? entry.borderBoxSize[0]
                : { blockSize: this.contentRect.height, inlineSize: this.contentRect.width };
            this.update();
            this.resize(this);
        };
        const throttleCallback = needThrottle ? throttle(callback, 300, { leading: true }) : callback;
        this.effect(() => {
            const ro = new ResizeObserver(throttleCallback);
            ro.observe(this, {});
            return () => ro.disconnect();
        }, () => []);
    }
}
__decorate([
    emitter
], DuoyunResizeBaseElement.prototype, "resize", void 0);
//# sourceMappingURL=resize.js.map